const npiData = [
    {
        "providerID": 803883,
        "providerVersionID": 1,
        "effectiveBeginDate": "2009-02-14T21:46:11.637Z",
        "providerContexts": [
            {
                "id": 982836,
                "providerID": 803883,
                "contextID": 79,
                "contextName": "South Carolina Web Claims Submission",
                "contextCode": "SCWCS",
                "contract": {
                    "id": 77,
                    "contextName": "State of South Carolina",
                    "contextCode": "SCSTATE"
                }
            }
        ],
        "providerNames": [
            {
                "id": 1855447,
                "contextID": 79,
                "personName": {
                    "lastName": "EZ DIABETIC SUPPLIES INC"
                },
                "nameType": "Business"
            }
        ],
        "providerNumbers": [
            {
                "id": 3119398,
                "number": "1689677023",
                "numberType": "NPI",
                "effectiveStartDate": "2009-02-14T21:46:11.637Z",
                "contextID": 79
            }
        ],
        "providerDemographics": [
            {
                "id": 1509881,
                "contextID": 79,
                "communication": {
                    "id": 4026281,
                    "contextID": 79,
                    "contact": null,
                    "address": {
                        "streetNumber": "61 STATE RD",
                        "city": "WEST BATH",
                        "stateOrProvince": "ME",
                        "postalCode": "45301"
                    },
                    "phone": {
                        "number": "8003936603"
                    }
                }
            }
        ],
        "providerProviderType": [
            {
                "id": 1518074,
                "contextID": 79,
                "typeCode": "SVP",
                "typeDesc": "DME Provider",
                "activeIndicator": "Y"
            }
        ]
    }
];
export default npiData;